import { render, staticRenderFns } from "./EditTaskActivityGiftDialog.vue?vue&type=template&id=0406e44b&scoped=true"
import script from "./EditTaskActivityGiftDialog.vue?vue&type=script&lang=js"
export * from "./EditTaskActivityGiftDialog.vue?vue&type=script&lang=js"
import style0 from "./EditTaskActivityGiftDialog.vue?vue&type=style&index=0&id=0406e44b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0406e44b",
  null
  
)

export default component.exports